import styled from '@emotion/styled';
import { responsiveFontSize } from '@presentation/styles';
import { Button } from '../Button';

export const Background = styled.div`
  background: ${(props) => props.theme.color.blue.default};
`;

export const Flex = styled.div`
  width: 100%;
  padding: 40px 30px;
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  flex: 1;
  color: ${(props) => props.theme.color.light.default};
  max-width: 600px;
`;

export const Title = styled.div`
  ${responsiveFontSize(28, 2)};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 700;
`;

export const Subtitle = styled.p`
  margin-top: 0;
  margin-top: 10px;
  ${responsiveFontSize(18, 1)};
`;

export const ButtonStyled = styled(Button)`
  width: auto;
  margin-top: 20px;
`;
